// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenu_wrapper__dDUr5","logo":"MobileMenu_logo__eq+7O","menu":"MobileMenu_menu__EQptE","controls":"MobileMenu_controls__IAOUM","control":"MobileMenu_control__Czgue"};